import { useEffect, useRef, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { supabase } from "../supabaseClient";
import { useToken } from "../context/TokenContext";
import YildizArkaplan from "../components/YildizArkaplan";

export default function OdemeSonuc() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const { user, fetchBalance } = useToken();
  const [durum, setDurum] = useState("kontrol"); // kontrol | basarili | basarisiz
  const [eklenenToken, setEklenenToken] = useState(0);
  const [hata, setHata] = useState("");
  const dogrulaRef = useRef(false);

  useEffect(() => {
    const status = searchParams.get("status");
    const iyzicoToken = searchParams.get("token");

    if (!iyzicoToken) {
      setDurum("basarisiz");
      setHata("Ödeme token'ı bulunamadı.");
      return;
    }

    if (status === "failure") {
      setDurum("basarisiz");
      setHata("Ödeme işlemi başarısız oldu.");
      return;
    }

    if (!user || dogrulaRef.current) return;
    dogrulaRef.current = true;

    // Başarılı — doğrula ve token yükle
    const dogrula = async () => {
      try {
        const { data, error } = await supabase.functions.invoke("odeme-dogrula", {
          body: {
            token: iyzicoToken,
            userId: user.id,
            userEmail: user.email,
            userAd: user.user_metadata?.full_name || user.email?.split('@')[0],
          },
        });

        if (error || !data?.success) {
          setDurum("basarisiz");
          setHata(data?.error || "Ödeme doğrulanamadı.");
          return;
        }

        setEklenenToken(data.eklenenToken);
        setDurum("basarili");

        if (user?.id) fetchBalance(user.id);

        setTimeout(() => navigate("/profil"), 3000);
      } catch (err) {
        setDurum("basarisiz");
        setHata("Sunucu hatası. Destek ile iletişime geçin.");
      }
    };

    dogrula();
  }, [user]); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <div style={{
      minHeight: "100vh",
      background: "linear-gradient(180deg, #0a0718 0%, #110d24 40%, #0d0a1a 100%)",
      position: "relative", fontFamily: "'Trebuchet MS', Tahoma, sans-serif",
      maxWidth: 420, margin: "0 auto",
      display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center",
    }}>
      <style>{`
        @keyframes spin { from { transform: rotate(0deg); } to { transform: rotate(360deg); } }
        @keyframes kart-gir { from { opacity: 0; transform: translateY(24px); } to { opacity: 1; transform: translateY(0); } }
        * { box-sizing: border-box; margin: 0; padding: 0; }
      `}</style>

      <YildizArkaplan />

      <div style={{ position: "relative", zIndex: 1, padding: "32px 24px", textAlign: "center", animation: "kart-gir 0.6s ease" }}>

        {durum === "kontrol" && (
          <>
            <div style={{ fontSize: 56, marginBottom: 20, animation: "spin 1.5s linear infinite", display: "inline-block" }}>🔮</div>
            <div style={{ fontSize: 20, fontWeight: 700, color: "#fff", marginBottom: 8 }}>Ödeme doğrulanıyor...</div>
            <div style={{ fontSize: 14, color: "rgba(255,255,255,0.5)" }}>Lütfen bekleyin</div>
          </>
        )}

        {durum === "basarili" && (
          <>
            <div style={{ fontSize: 72, marginBottom: 20 }}>✅</div>
            <div style={{ fontSize: 24, fontWeight: 800, color: "#fff", fontFamily: "Georgia, serif", marginBottom: 10 }}>
              Ödemeniz Alındı!
            </div>
            <div style={{
              background: "rgba(249,203,66,0.15)", border: "1px solid rgba(249,203,66,0.3)",
              borderRadius: 20, padding: "12px 28px", display: "inline-block",
              fontSize: 22, color: "#F9CB42", fontWeight: 800, marginBottom: 16,
            }}>
              +{eklenenToken} 🪙 Token Yüklendi
            </div>
            <div style={{ fontSize: 14, color: "rgba(255,255,255,0.5)", marginBottom: 28 }}>
              Profilinize yönlendiriliyorsunuz...
            </div>
            <button
              onClick={() => navigate("/profil")}
              style={{
                padding: "14px 32px", borderRadius: 14,
                background: "linear-gradient(135deg, #7c3aed, #a855f7)",
                border: "none", color: "#fff", fontSize: 15, fontWeight: 700, cursor: "pointer",
              }}
            >
              Profile Git →
            </button>
          </>
        )}

        {durum === "basarisiz" && (
          <>
            <div style={{ fontSize: 72, marginBottom: 20 }}>❌</div>
            <div style={{ fontSize: 22, fontWeight: 800, color: "#fff", fontFamily: "Georgia, serif", marginBottom: 10 }}>
              Ödeme Başarısız
            </div>
            <div style={{
              background: "rgba(239,68,68,0.1)", border: "1px solid rgba(239,68,68,0.3)",
              borderRadius: 14, padding: "12px 20px", marginBottom: 24,
              fontSize: 13, color: "#FCA5A5", lineHeight: 1.6,
            }}>
              {hata}
            </div>
            <button
              onClick={() => navigate("/token-kazan")}
              style={{
                padding: "14px 32px", borderRadius: 14,
                background: "rgba(255,255,255,0.08)", border: "1px solid rgba(255,255,255,0.2)",
                color: "#fff", fontSize: 14, fontWeight: 700, cursor: "pointer",
              }}
            >
              Tekrar Dene
            </button>
          </>
        )}

      </div>
    </div>
  );
}
